import {
  Box,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
} from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BatchColumnStatusRoute from "./BatchColumnStatusRoute";
import {
  dateFormated,
  presentFormatedData,
} from "../functionalComponents/dataFormatFunctions";
import POTabs from "./POTabs";
import axios from "axios";
import { appUrl } from '../../../../../utils/config';
import { fetchUserAssociation, fetchSLFromPODashboard, clearSLFromPODashboard } from "../../../containers/actions/common/purchaseOrderAction";
import jwt_decode from "jwt-decode";
import CollapsePODetails from "./CollapsePODetails";
import EditAboRisk from "./POColumns/EditABORisk";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import AuditReportNew from "./AuditReportNew";
import ViewThreeRecentChanges from "./ViewThreeRecentChanges";
import ViewASNDetails from "./ViewASNDetails";
import ViewReasonCode from "./ViewReasonCode";
// import ApproveRejectConsumedBatch from "./ApproveRejectConsumedBatch";
import VarianceMismatchDialog from "../sasl/deliveryScheduleBatchTable/VarianceMismatchDialog";
import { fetchPOLineAuditDetailsNew } from "../../../containers/actions/common/purchaseOrderNew";
import { FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING } from "../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";
import { useApiBaseUrl } from "../CommonMethods/CommonMethods";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import StyledButton from "../../../../common/models/Button";
import {makeStyles} from "@material-ui/core/styles";
// ----------------------------------------------------------------------
// STYLES
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  tableCellBody: {
    padding: "10px",
  },
  // Columns 1-5 (Icon, PO Number, Product Code / Description, Qty, UOM)
  col1to5: {
    fontSize: "14px",
    
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
  // Column 6 (Date)
  col6: {
    fontSize: "14px",
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
  col7: {
    "&.MuiTableCell-root": {
      fontSize: "12px",
      [theme.breakpoints.up(1680)]: {
        fontSize: "14px",
      },
    },
  },
  // Columns 8-10 (ABO Risk, PO Status, Action)
  col8to10: {
    "&.MuiTableCell-root": {
      fontSize: "12px", // Default for <1680px
      [theme.breakpoints.up(1680)]: {
        fontSize: "14px", // For >=1680px
      },
    },
    "& .MuiButton-root": {
      fontSize: "inherit !important",
      padding: 0,
      minWidth: 0,
      //fontSize: "inherit",
      backgroundColor: "transparent",
      boxShadow: "none",
      textTransform: "none", // if you want to avoid uppercase
    },
    "& .MuiTextField-root": {
      fontSize: "inherit", // Ensure TextField inherits font size
    },
    "& .MuiSvgIcon-root": {
      fontSize: "inherit", // Ensure icons inherit font size
    },
  },
  tableContainer: {
  },
  title: {
    fontWeight: 500,
    fontSize: "1.5rem",
    textAlign: "left",
    paddingBottom: "0.3rem",
  },
  headerCell: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    height: "28px",
    padding: "10px",
    zIndex: 3,
  },
  groupedHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    position: "sticky",
    padding: "10px",
    top: 0,
    zIndex: 3,
    border: "none",
    paddingBottom: "0px",
  },
 
}));
const renderPOStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: // Created
      color = "#B4B4B4";
      break;
    case 23: // Under confirmation
      color = "#E78A00";
      break;
    case 22: // Shared with CMO
      color = "#2196F3";
      break;
    case 25: // Confirmed
    case 29: // Under Revision
    case 31: // Revised
    case 27: // Approved
      color = "#329429";
      break;
    case 30: // Delivery Complete
      color = "#707070";
      break;
    case 24: // Rejected By CMO
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }

  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
        // fontSize: "inherit",
      }}
    >
      {statusText}
    </Typography>
  );
};

const PurchaseOrderTabTable = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    fetchPurchaseOrderDataLoading,
    rowData,
    errors,
    handleRefresh,
    handleQuickSummaryRefresh,
    selectedPO,
    setSelectedPO,
    featuresAccess,
    selectedCMOs,
    selectedBrands,
  } = props;

  const [poData, setPOData] = useState(rowData);
  const [rowInfo, setRowInfo] = useState(null);
  const [open, setOpen] = useState({}); // tracks row expansions
  const [openedPOTab, setOpenedPOTab] = useState({});
  // BCM-737: Daily-PO-Update email deep link (?poNumber=<PO>[&tab=batchAllocation]).
  // location gives us the query string; the ref ensures we apply it exactly once.
  const location = useLocation();
  const deepLinkHandledRef = useRef(false);
  const [openAction, setOpenAction] = useState(false);
  const [openReasonCode, setOpenReasonCode] = useState(false);
  const [openASN, setOpenASN] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPoHistory, setOpenPoHistory] = useState(false);
  const [openApproveRejectBatch, setOpenApproveRejectBatch] = useState(false);
  // Sync PO / Sync Inventory (BCM-534)
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncResultDialog, setSyncResultDialog] = useState({
    open: false,
    success: false,
    title: "",
    message: "",
  });
  const [openRequestCancelPO, setOpenRequestCancelPO] = useState(false);
  const [openReviewPOCancellation, setOpenReviewPOCancellation] = useState(false);
  const [selectedCancellationReason, setSelectedCancellationReason] = useState("");
  const [cancellationComment, setCancellationComment] = useState("");
  const [reasonCodes, setReasonCodes] = useState([]);
  const [reasonCodesLoading, setReasonCodesLoading] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [commentErrorText, setCommentErrorText] = useState("");
  const [requestCancelPOLoading, setRequestCancelPOLoading] = useState(false);
  const [requestCancelPOError, setRequestCancelPOError] = useState("");
  const [reviewCancellationLoading, setReviewCancellationLoading] = useState(false);
  const [reviewCancellationError, setReviewCancellationError] = useState("");
  const prevLoadingRef = useRef(false); // Track previous loading state to detect refresh completion
  
  const openMenu = Boolean(anchorEl);
  const userAssociationData = useSelector(
    state => state.pcmp?.common?.purchaseOrder?.userAssociationResult || null
  );
  
  // SL Details from PO Dashboard
  const slDetailsFromPODashboard = useSelector(
    (state) => state?.pcmp?.common?.purchaseOrder?.slDetailsFromPODashboard || {}
  );
  const slDetailsFromPODashboardLoading = useSelector(
    (state) => state?.pcmp?.common?.purchaseOrder?.slDetailsFromPODashboardLoading
  );

  // Sync PO / Sync Inventory are not applicable when fetchSLFromPODashboard returns
  // subContractingPOs: false for the row the action menu was opened on; when the
  // value is absent the actions behave as before.
  const syncNotApplicable =
    (slDetailsFromPODashboard?.[rowInfo?.scheduleLineDetails?.schrockenSLID]?.data
      ?.scheduleLineDetails?.subContractingPOs ??
      rowInfo?.scheduleLineDetails?.subContractingPOs) === false;




  const isUserAssociatedWithAnyPO = (rowData, userAssociationData) => {
    if (!Array.isArray(rowData) || !userAssociationData) {
      return false;
    }

    // Handle both direct data and nested data structure
    const associations = userAssociationData.data || userAssociationData;
    
    const {
      associatedProductTypesList = [],
      associatedBrandList = [],
      associatedCMOList = [],
    } = associations;

  
    return rowData.some(poItem => {
      const scheduleLine = poItem.scheduleLineDetails;
      if (!scheduleLine) return false;
      const productTypeID = scheduleLine.productTypeID;
      const brand = scheduleLine.brand;
      const vendorMosymphonyID = scheduleLine.vendorMosymphonyID;

  
      const isProductTypeMatched = associatedProductTypesList.includes(productTypeID);

      const isBrandMatched = associatedBrandList.some(b => b?.trim()?.toUpperCase() === brand?.trim()?.toUpperCase());
      const isVendorMatched = associatedCMOList.includes(vendorMosymphonyID);
      
      
      return isProductTypeMatched && isBrandMatched && isVendorMatched;
    });
  };
  
  // Extract schedule line details from slDetailsFromPODashboard
  const slDetailsData = Object.values(slDetailsFromPODashboard)
    .filter(item => item?.data?.scheduleLineDetails)
    .map(item => ({ scheduleLineDetails: item.data.scheduleLineDetails }));
  
  const showPencilIcon = isUserAssociatedWithAnyPO(
    slDetailsData.length > 0 ? slDetailsData : rowData, 
    userAssociationData
  )


  const poLineAuditsNewData = useSelector(
    (state) => state?.pcmp?.common?.poNew?.poLineAuditsNew
  );
  const poLineAuditsNewDataLoading = useSelector(
    (state) => state?.pcmp?.common?.poNew?.poLineAuditsNewLoading
  );


  // Action button click
  const handleClick = (event, row, index) => {
    setAnchorEl(event.currentTarget);
    setRowInfo(row);
    // We are no longer setting selectedPO here, so it doesn't hide other rows
  };


  const token = localStorage.getItem('authToken');
useEffect(() => {
  if (token) {
    try {
      const payload = jwt_decode(token);
      
      // If userAssociationData is not loaded, fetch it
      if (!userAssociationData && payload.saas_user_id) {
        dispatch(fetchUserAssociation(payload.saas_user_id))
          .catch((error) => {
            console.error("Error fetching user associations:", error);
          });
      }
    } catch (e) {
      console.error('Invalid token', e);
    }
  }
}, [token, userAssociationData, dispatch]);
  // Action menu close
  const handleClose = () => {
    setAnchorEl(null);
  };


 

  useEffect(() => {
    if (selectedPO === null) {
      // Close all expanded rows
      setOpen({});
    }
  }, [selectedPO]);

  
  const handleRowToggle = (poNumber, schrockenSLID) => {
    // Toggle the open state for this row
    const isOpening = !open[poNumber];
    
    setOpen((prevState) => ({
      ...prevState,
      [poNumber]: !prevState[poNumber],
    }));

    // If we are opening this row, set selectedPO to its ID (focus mode)
    // If we are closing it, set selectedPO back to null (show all rows)
    const newSelectedPO = open[poNumber] ? null : poNumber;
    setSelectedPO(newSelectedPO);

    // Tell parent component about focus mode change
    props.onFocusModeChange(newSelectedPO !== null);

    // Reset the opened tab to 0
    setOpenedPOTab((prevState) => ({
      ...prevState,
      [poNumber]: 0,
    }));

    // If opening the row, clear props data first, then fetch fresh data
    if (isOpening && schrockenSLID) {
      // Clear props data for this SL to ensure fresh fetch
      dispatch(clearSLFromPODashboard(schrockenSLID));
      // Fetch fresh SL details
      dispatch(fetchSLFromPODashboard(schrockenSLID))
        .catch((error) => {
          console.error("Failed to fetch SL details for", schrockenSLID, error);
        });
    }
    
    // If closing the row, clear props data for this SL
    if (!isOpening && schrockenSLID) {
      dispatch(clearSLFromPODashboard(schrockenSLID));
    }
  };

  // Header-row editors (e.g. ABO Risk) live outside POTabs, so they only received
  // the parent handleRefresh — which reloads the dashboard lists but NOT the
  // per-SL details that the expanded tabs (Product Details) render from. The SL
  // slice is cleared per schrockenSLID, so without this refetch those tabs read
  // an empty scheduleLineDetails and every field shows blank / read-only even
  // though the save succeeded. Mirrors handleRefreshWithSLData in POTabs/index.jsx.
  const handleRefreshWithSLData = (row) => (type) => {
    if (handleRefresh) {
      handleRefresh(type);
    }
    const schrockenSLID = row?.scheduleLineDetails?.schrockenSLID;
    if (schrockenSLID) {
      dispatch(fetchSLFromPODashboard(schrockenSLID)).catch((error) => {
        console.error("Failed to refresh SL details for", schrockenSLID, error);
      });
    }
  };

  // Switch between tabs inside the expanded row
  const handleOpenPOTab = (poNumber, val) => {
    setOpenedPOTab((prevState) => ({
      ...prevState,
      [poNumber]: val,
    }));
  };

  // BCM-737: deep-link handling moved to the URL-driven effect above
  // (reads location.search via useLocation, guarded by deepLinkHandledRef).
  // The earlier props-based effect (deepLinkPoNumber/deepLinkTab) was replaced.

  // Open PO history
  const handleOpenPoHistory = () => {
    setOpenPoHistory(true);
    setAnchorEl(null);
  };

  // Open three most recent changes
  const handleOpenAction = () => {
    setAnchorEl(null);
    setOpenAction(true);
  };

  // Open reason code
  const handleopenReasonCodes = () => {
    setAnchorEl(null);
    setOpenReasonCode(true);
  };

  const handleOpenRequestCancelPO = () => {
    setAnchorEl(null);
    setSelectedCancellationReason("");
    setCancellationComment("");
    setOpenRequestCancelPO(true);
  };

  const handleCloseRequestCancelPO = () => {
    setOpenRequestCancelPO(false);
    setRequestCancelPOError("");
  };

  const handleContinueRequestCancelPO = async () => {
    const scheduleLineDetails = rowInfo?.scheduleLineDetails || {};
    const batchDetails = rowInfo?.batchDetails || {};

    let userEmail = "";
    try {
      const tokenData = jwt_decode(localStorage.getItem("authToken"));
      userEmail = tokenData.email_address || "";
    } catch (e) {
      console.error("Error decoding token", e);
    }

    const requestPayload = {
      vendorMosymphonyID: scheduleLineDetails.vendorMosymphonyID,
      brandOwnerMosymphonyID: scheduleLineDetails.brandOwnerMosymphonyID,
      cancellationRequestStatus: "pending",
      cancellationRequestedBy: userEmail,
      schrockenSLID: scheduleLineDetails.schrockenSLID,
      scheduleAgreementNumber: scheduleLineDetails.scheduleAgreementNumber,
      fgMaterialCode: scheduleLineDetails.fgMaterialCode,
      fgMaterialDescription: scheduleLineDetails.fgMaterialName,
      vendorBatchNumber: batchDetails.vendorBatchNumber || null,
    };

    setRequestCancelPOLoading(true);
    setRequestCancelPOError("");
    try {
      await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/RequestPOCancellation`,
        requestPayload
      );
      setOpenRequestCancelPO(false);
      setAnchorEl(null);
      if (handleRefresh) handleRefresh();
    } catch (err) {
      console.error("Error requesting PO cancellation", err);
      setRequestCancelPOError("Failed to submit cancellation request. Please try again.");
    } finally {
      setRequestCancelPOLoading(false);
    }
  };

  const handleOpenReviewPOCancellation = () => {
    setAnchorEl(null);
    setSelectedCancellationReason("");
    setCancellationComment("");
    setOpenReviewPOCancellation(true);
  };

  const handleCloseReviewPOCancellation = () => {
    setOpenReviewPOCancellation(false);
    setReviewCancellationError("");
  };

  const handleSubmitReviewCancellation = async (cancellationRequestStatus) => {
    if (!selectedCancellationReason || selectedCancellationReason === "") {
      if (!cancellationComment || cancellationComment.trim() === "") {
        setCommentError(true);
        setCommentErrorText("Comment is mandatory when no reason code is selected.");
        return;
      }
    }

    setCommentError(false);
    setCommentErrorText("");

    const scheduleLineDetails = rowInfo?.scheduleLineDetails || {};
    const batchDetails = rowInfo?.batchDetails || {};
    let reviewedBy = "";
    try {
      const tokenData = jwt_decode(localStorage.getItem("authToken"));
      reviewedBy = tokenData.email_address || "";
    } catch (e) {
      console.error("Error decoding token", e);
    }

    const payload = {
      vendorMosymphonyID: scheduleLineDetails.vendorMosymphonyID,
      brandOwnerMosymphonyID: scheduleLineDetails.brandOwnerMosymphonyID,
      schrockenSLID: scheduleLineDetails.schrockenSLID,
      cancellationRequestStatus,
      cancellationRequestedBy: scheduleLineDetails.cancellationRequestedBy,
      cancellationReviewedBy: reviewedBy,
      cancellationReasonCode: selectedCancellationReason || null,
      cancellationComment: cancellationComment || null,
      fgMaterialCode: scheduleLineDetails.fgMaterialCode || null,
      fgMaterialDescription: scheduleLineDetails.fgMaterialName || null,
      scheduleAgreementNumber: scheduleLineDetails.scheduleAgreementNumber || null,
      vendorBatchNumber: batchDetails.vendorBatchNumber || null,
    };


    setReviewCancellationLoading(true);
    setReviewCancellationError("");
    try {
      await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/RequestPOCancellation`,
        payload
      );
      setOpenReviewPOCancellation(false);
      setAnchorEl(null);
      if (handleRefresh) handleRefresh();
    } catch (err) {
      console.error("Error reviewing PO cancellation", err);
      setReviewCancellationError("Failed to submit. Please try again.");
    } finally {
      setReviewCancellationLoading(false);
    }
  };

  const handleApproveReviewCancellation = () => handleSubmitReviewCancellation("approved");

  const handleRejectReviewCancellation = () => handleSubmitReviewCancellation("rejected");

  // Fetch reason codes when review dialog opens
  const fetchReasonCodes = async () => {
    setReasonCodesLoading(true);
    try {
      const resp = await axios.post(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`);
      const list = resp?.data?.data?.reasonCodeList || [];
      setReasonCodes(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error('Failed to fetch reason codes', err);
      setReasonCodes([]);
    } finally {
      setReasonCodesLoading(false);
    }
  };

  useEffect(() => {
    if (openReviewPOCancellation) {
      fetchReasonCodes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openReviewPOCancellation]);

  // Open Approve/Reject Consumed Batch
  const handleApproveRejectBatchOpen = () => {
    setAnchorEl(null);
    setOpenApproveRejectBatch(true);
  };

  // ── Sync PO / Sync Inventory (BCM-534) ──────────────────────────────────
  // Self-contained inside the PO dashboard action dropdown. Calls the SAME
  // endpoints with the SAME payload shape used by the digitalized batch page,
  // via inline axios (matching this dashboard's existing inline-API pattern).
  const toISODate = (d) => new Date(d).toISOString().slice(0, 10); // "YYYY-MM-DD"
  const endOfToday = () => `${toISODate(new Date())}T23:59:59Z`;

  // The list row's scheduleLineDetails is slim — it can be missing vendorNumber
  // / creationDate, which the sync payloads need. Resolve the FULL schedule-line
  // detail: prefer what's already loaded (row expanded), else fetch on demand.
  const resolveScheduleLineDetail = async (row) => {
    let sl = { ...(row?.scheduleLineDetails || {}) };
    const slID = sl.schrockenSLID;
    // fetchSLFromPODashboard nests the SL under data.data.scheduleLineDetails
    // (the stored redux value and the raw axios res.data share this shape).
    // Tolerate a flat shape too, just in case.
    const extractSL = (body) =>
      body?.data?.scheduleLineDetails || body?.scheduleLineDetails || null;

    const cached = extractSL(slDetailsFromPODashboard?.[slID]?.data);
    if (cached) sl = { ...sl, ...cached };

    if (slID && !sl.vendorNumber) {
      try {
        const res = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchSLFromPODashboard`,
          { schrockenSLID: slID, includeDeleted: false }
        );
        const fetched = extractSL(res?.data);
        if (fetched) sl = { ...sl, ...fetched };
      } catch (e) {
        // keep whatever we already have
      }
    }
    return sl;
  };

  // Sync PO → /updateSASLDSDataNew. Range: SA creation date → today.
  //
  // Was /updateSASLDataNew, which only wrote SA + SL: its fetchSAPData
  // returned just SASLDetails and discarded the BOM portion of the SAP
  // response, so a component/material code change in SAP never reached
  // MoSymphony from this button (it only worked via the support login,
  // which already used /updateSASLDSDataNew). This endpoint writes
  // SA + SL + DS + BOM + component allocation.
  const handleSyncPO = async () => {
    setAnchorEl(null);
    setSyncLoading(true);
    try {
      const sl = await resolveScheduleLineDetail(rowInfo);
      // SA creation date (batch page uses agreementDate; on the dashboard the
      // schedule line carries creationDate). Slice the date part directly to
      // avoid timezone shifts.
      const startSrc = sl.agreementDate || sl.creationDate;
      const startDate = startSrc
        ? `${String(startSrc).slice(0, 10)}T00:00:00Z`
        : endOfToday();
      const payload = {
        dateRanges: [{ startDate, endDate: endOfToday() }],
        vendorNumber: sl.vendorNumber ? [sl.vendorNumber] : [],
        vendorPlant: sl.vendorPlant ? [sl.vendorPlant] : [],
        poNumber: sl.scheduleAgreementNumber ? [sl.scheduleAgreementNumber] : [],
      };
      const res = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSASLDSDataNew`,
        payload
      );
      const ok = res?.data?.success === true;
      setSyncResultDialog({
        open: true,
        success: ok,
        title: ok ? "PO Synced Successfully" : "Sync PO Failed",
        message: ok
          ? "Purchase Order data has been synced from SAP successfully."
          : res?.data?.message || "An error occurred while syncing PO data.",
      });
    } catch (err) {
      setSyncResultDialog({
        open: true,
        success: false,
        title: "Sync PO Failed",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "An error occurred while syncing PO data.",
      });
    } finally {
      setSyncLoading(false);
    }
  };

  // Sync Inventory → fetch this PO line's component material codes, then call
  // /syncInventoryDataNew (material-level sync). inventoryBatchNumber is sent
  // empty and dateRanges carries a single blank range (snapshot:'S' / zeroStockLines:'N').
  const handleSyncInventory = async () => {
    setAnchorEl(null);
    setSyncLoading(true);
    try {
      const sl = await resolveScheduleLineDetail(rowInfo);
      const slID = sl.schrockenSLID;
      // materialNumber          = component codes for this PO line.
      // inventoryBatchNumber    = lot numbers already allocated for this PO line
      //                           (componentAllocationDataList[].lotNumberAllocationDetails[].lotNumber).
      let materialNumber = [];
      if (slID) {
        const compRes = await axios.get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNewDirect/${slID}`
        );
        const list = compRes?.data?.data?.componentAllocationDataList || [];
        materialNumber = list
          .map((c) => c?.componentAllocationDetails?.componentCode)
          .filter(Boolean);
      }
      const past = new Date();
      past.setFullYear(past.getFullYear() - 1);
      const payload = {
        dateRanges: [{ startDate: `${toISODate(past)}T00:00:00Z`, endDate: endOfToday() }],
        vendorNumber: sl.vendorNumber ? [sl.vendorNumber] : [],
        vendorPlant: sl.vendorPlant ? [sl.vendorPlant] : [],
        materialNumber,
        inventoryBatchNumber: [],
        snapshot: "S",
        zeroStockLines: "N",
      };
      const res = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/syncInventoryDataNew`,
        payload
      );
      const ok = res?.data?.success === true;
      setSyncResultDialog({
        open: true,
        success: ok,
        title: ok ? "Inventory Synced Successfully" : "Sync Inventory Failed",
        message: ok
          ? "Inventory data has been synced from SAP successfully."
          : res?.data?.message || "An error occurred while syncing inventory data.",
      });
    } catch (err) {
      setSyncResultDialog({
        open: true,
        success: false,
        title: "Sync Inventory Failed",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "An error occurred while syncing inventory data.",
      });
    } finally {
      setSyncLoading(false);
    }
  };

  useEffect(() => {
    setPOData((prevPOData) => {
      if (!Array.isArray(rowData)) return rowData;

      const stillPresent =
        !selectedPO ||
        rowData.some(
          (r) => (r?.scheduleLineDetails?.scheduleAgreementNumber || "") === selectedPO
        );
      if (stillPresent) return rowData;

      // The focused row fell out of the refreshed/filtered list - e.g. BMS proposing
      // a new Qty/Date moves its status out of a status-based filter like "Confirmed".
      // Keep it visible (refreshed with whatever latest schedule line details we
      // already have) instead of leaving focus mode pointed at a row that no longer
      // exists, which hides every row and renders as if the table never loaded.
      const lastKnownRow = (prevPOData || []).find(
        (r) => (r?.scheduleLineDetails?.scheduleAgreementNumber || "") === selectedPO
      );
      if (!lastKnownRow) return rowData;

      const apiData =
        slDetailsFromPODashboard?.[lastKnownRow?.scheduleLineDetails?.schrockenSLID]?.data;
      // Merge every nested section the SL-details fetch can return, not just
      // scheduleLineDetails - e.g. Batch Status reads row.batchDetails directly,
      // so a Batch Allocation edit needs that section refreshed here too.
      const refreshedRow = apiData
        ? {
            ...lastKnownRow,
            scheduleLineDetails: {
              ...lastKnownRow.scheduleLineDetails,
              ...(apiData.scheduleLineDetails || {}),
            },
            batchDetails: apiData.batchDetails || lastKnownRow.batchDetails,
            productDetails: apiData.productDetails || lastKnownRow.productDetails,
            deliveryDetails: apiData.deliveryDetails || lastKnownRow.deliveryDetails,
            pricingDetails: apiData.pricingDetails || lastKnownRow.pricingDetails,
          }
        : lastKnownRow;

      return [...rowData, refreshedRow];
    });
  }, [rowData, fetchPurchaseOrderDataLoading, slDetailsFromPODashboard, selectedPO]);

  // BCM-737: apply the Daily-PO-Update email deep link. When the dashboard is
  // opened with ?poNumber=<PO>[&tab=batchAllocation], wait for the PO list to
  // load, focus + expand that PO, and (for allocation links) pre-select the
  // Batch Allocation tab (index 2). Runs exactly once.
  //
  // Ordering matters: POTabs seeds its active tab from `openedPOTab` only at
  // mount and mounts lazily (Collapse unmountOnExit + slDetails spinner), with
  // no effect that re-syncs the tab afterwards. So `open` and `openedPOTab`
  // must be set together here — and we must NOT reuse handleRowToggle, which
  // forces the tab back to 0.
  useEffect(() => {
    if (deepLinkHandledRef.current) return;
    if (fetchPurchaseOrderDataLoading) return; // 1) wait for the PO list to load
    if (!Array.isArray(poData) || poData.length === 0) return;

    const params = new URLSearchParams(location.search || "");
    const urlPo = params.get("poNumber");
    if (!urlPo) return;
    // BCM-737: the dashboard search is already scoped to this PO, so the row
    // shows up filtered on its own - no need to auto-expand it. Only open the
    // row (and jump to Lot Allocation) when the link points there specifically.
    if (params.get("tab") !== "batchAllocation") return;

    const targetRow = poData.find(
      (r) =>
        String(r?.scheduleLineDetails?.scheduleAgreementNumber) === String(urlPo)
    );
    // Not in this list yet - the PO-scoped search results may still be on
    // their way. Leave the ref unset so this retries on the next poData
    // change rather than giving up permanently on the first list that loads.
    if (!targetRow) return;

    const poNumber = targetRow.scheduleLineDetails.scheduleAgreementNumber;
    const schrockenSLID = targetRow.scheduleLineDetails.schrockenSLID;
    const tabIndex = 2;

    deepLinkHandledRef.current = true;
    console.log(`[deepLink] opening PO ${poNumber} on tab "batchAllocation"`);

    // 2) focus + expand the PO row (focus mode hides the other rows)
    setSelectedPO(poNumber);
    props.onFocusModeChange(true);
    setOpen((prevState) => ({ ...prevState, [poNumber]: true }));
    // 3) pre-select the tab in the SAME update so POTabs reads it at mount
    setOpenedPOTab((prevState) => ({ ...prevState, [poNumber]: tabIndex }));

    if (schrockenSLID) {
      dispatch(clearSLFromPODashboard(schrockenSLID));
      dispatch(fetchSLFromPODashboard(schrockenSLID)).catch((error) => {
        console.error("Failed to fetch SL details for", schrockenSLID, error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPurchaseOrderDataLoading, poData, location.search]);

  // Re-fetch SL details for all open rows after refresh completes
  useEffect(() => {
    // Only fetch when loading transitions from true to false (refresh just completed)
    const wasLoading = prevLoadingRef.current;
    const isLoading = fetchPurchaseOrderDataLoading;
    
    // Update ref for next comparison
    prevLoadingRef.current = isLoading;
    
    // Only proceed if we just finished loading (was loading, now not loading)
    if (wasLoading && !isLoading && rowData && rowData.length > 0) {
      // Get all open rows
      const openRows = Object.keys(open).filter(poNumber => open[poNumber]);
      
      if (openRows.length > 0) {
        // Find schrockenSLIDs for all open rows and fetch fresh data
        const schrockenSLIDsToFetch = [];
        rowData.forEach(row => {
          const poNumber = row?.scheduleLineDetails?.scheduleAgreementNumber || "";
          if (openRows.includes(poNumber)) {
            const schrockenSLID = row?.scheduleLineDetails?.schrockenSLID;
            if (schrockenSLID) {
              schrockenSLIDsToFetch.push(schrockenSLID);
            }
          }
        });

        // Clear props data and fetch fresh for all open rows
        schrockenSLIDsToFetch.forEach(schrockenSLID => {
          dispatch(clearSLFromPODashboard(schrockenSLID));
          dispatch(fetchSLFromPODashboard(schrockenSLID))
            .catch((error) => {
              console.error("Failed to refresh SL details for", schrockenSLID, error);
            });
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPurchaseOrderDataLoading, rowData]);

  useEffect(() => {
    if (openPoHistory) {
      dispatch({
        type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
        payload: true,
      });
      dispatch(
        fetchPOLineAuditDetailsNew({
          schrockenSLID: rowInfo?.scheduleLineDetails?.schrockenSLID || "",
          viewRecentChanges: false,
        })
      );
    }
  }, [openPoHistory, dispatch, rowInfo]);

  useEffect(() => {
    if (openAction) {
      dispatch({
        type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
        payload: true,
      });
      dispatch(
        fetchPOLineAuditDetailsNew({
          schrockenSLID: rowInfo?.scheduleLineDetails?.schrockenSLID || "",
          viewRecentChanges: true,
        })
      );
    }
  }, [openAction, dispatch, rowInfo]);

  // --------------------------------------------------------------------
  // RENDER
  // --------------------------------------------------------------------
  return (
    <>
      <TableContainer
        style={{
          marginTop: "1rem",
          minHeight: "auto",
        }}
        component={Paper}
        className={classes.tableContainer}
      >
        <Table  style={{ borderCollapse: "collapse" }}>
          <TableHead className={`${classes.headerCell} default-table-styles`}>
            <TableRow>
              <TableCell className={`${classes.headerCell} ${classes.columnExpand}`} rowSpan={2} />
              <TableCell
                className={`${classes.headerCell} ${classes.columnPONumber}`}
                rowSpan={2}
                align="left"
              >
                PO Number
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnProduct}`}
                rowSpan={2}
                align="left"
              >
                Product Code / Description
              </TableCell>
              <TableCell
                className={classes.groupedHeader}
                colSpan={3}
                align="center"
              >
                Current Values
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnBatchStatus}`}
                rowSpan={2}
                align="center"
              >
                Batch Status
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnABORisk}`}
                rowSpan={2}
                align="left"
              >
                ABO/Priority
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnPOStatus}`}
                rowSpan={2}
                align="center"
              >
                PO Status
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.columnAction}`}
                rowSpan={2}
                align="center"
              >
                Action
              </TableCell>
            </TableRow>
            <TableRow>
              {/* Subheaders */}
              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px" }}
                className={`${classes.headerCell} ${classes.columnQty}`}
              >
                Qty
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={`${classes.headerCell} ${classes.columnUOM}`}
              >
                UoM
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={`${classes.headerCell} ${classes.columnDate}`}
              >
                Date
              </TableCell>
            </TableRow>
          </TableHead>

          {/* TABLE BODY */}
          {fetchPurchaseOrderDataLoading ? (
            <TableBody>
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={10}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : errors?.status === false ? (
            <TableBody>
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  textAlign: "center",
                  padding: "0.8rem",
                  //fontSize: "0.875rem",
                }}
              >
                <TableCell
                  colSpan={10}
                  align="center"
                  style={{ padding: "10px" }}
                >
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {/* No Data Case */}
              {poData?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}

              {/* Main Rows */}
              {poData.map((row, index) => {
                const poNumber =
                  row?.scheduleLineDetails?.scheduleAgreementNumber || "";

                // If a PO is selected (expanded) and this row is NOT the selected one, hide it.
                if (selectedPO && poNumber !== selectedPO) {
                  return null;
                }

                return (
                  <React.Fragment key={`row-${index}`}>
                    <TableRow>
                      <TableCell className={`${classes.tableCellBody} ${classes.col1to5}`}>
                        <IconButton
                          onClick={() => handleRowToggle(poNumber, row?.scheduleLineDetails?.schrockenSLID)}
                          size="small"
                        >
                          {open[poNumber] && selectedPO !== null ? (
                            <ExpandMoreIcon />
                          ) : (
                            <ChevronRightIcon />
                          )}
                        </IconButton>
                      </TableCell>

                      <TableCell className={`${classes.tableCellBody} ${classes.col1to5}`}>
                        {presentFormatedData(poNumber, "")}
                      </TableCell>

                      <TableCell className={`${classes.tableCellBody} ${classes.col1to5}`}>
                        {row?.scheduleLineDetails?.fgMaterialCode &&
                          row?.scheduleLineDetails?.fgMaterialName ? (
                          <>
                            {presentFormatedData(
                              row?.scheduleLineDetails?.fgMaterialCode
                            )}
                            <br />
                            {presentFormatedData(
                              row?.scheduleLineDetails?.fgMaterialName
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </TableCell>

                      <TableCell
                        align="right"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                        style={{
                          whiteSpace: "nowrap",
                          color: (() => {
                            
                            const targetQuantity = row?.scheduleLineDetails?.targetQuantity;
                            const committedQuantity = row?.scheduleLineDetails?.committedQuantity;
                            const qtyAcceptedFlag = row?.scheduleLineDetails?.qtyAcceptedFlag;
                            
                           
                            const acceptanceLimitForMore = row?.scheduleLineDetails?.acceptanceLimitForMoreDeliveryQuantityChangeByCMO ?? 0;
                            const acceptanceLimitForLess = row?.scheduleLineDetails?.acceptanceLimitForLessDeliveryQuantityChangeByCMO ?? 0;
                          
                            
                            if (
                              targetQuantity == null || 
                              committedQuantity == null || 
                              targetQuantity <= 0 || 
                              committedQuantity < 0
                            ) {
                              return "black";
                            }
                          
                           
                            if (qtyAcceptedFlag !== true) {
                              return "black";
                            }
                          
                            
                            const lowerDelta = (targetQuantity * acceptanceLimitForLess) / 100;
                            const upperDelta = (targetQuantity * acceptanceLimitForMore) / 100;
                            
                            const lowerBound = targetQuantity - lowerDelta;
                            const upperBound = targetQuantity + upperDelta;
                          
                          
                            if (committedQuantity === targetQuantity) {
                              return "black";
                            }
                          
                            
                            if (committedQuantity >= lowerBound && committedQuantity <= upperBound) {
                              return "black";
                            }
                          
                           
                            return "red";
                          })(),
                        }}
                      >
                        {presentFormatedData(
                          row?.scheduleLineDetails?.committedQuantity,
                          ""
                        )}
                      </TableCell>

                      <TableCell
                        align="left"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {presentFormatedData(
                          row?.scheduleLineDetails?.targetQuantityUOM
                        )}
                      </TableCell>

                      <TableCell
                        align="left"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {(() => {
                          const statisticalDate = row?.scheduleLineDetails?.statisticalDate;
                          const committedDeliveryDate = row?.scheduleLineDetails?.committedDeliveryDate;
                          const deliveryDateAccepetedFlag = row?.scheduleLineDetails?.deliveryDateAccepetedFlag;
                          const acceptanceLimitForLaterDeliveryDateChangeByCMO = 
                            row?.scheduleLineDetails?.acceptanceLimitForLaterDeliveryDateChangeByCMO || 0;
                        


                          const shouldHighlightDateRed = (() => {
                            if (!statisticalDate || !committedDeliveryDate || deliveryDateAccepetedFlag !== true) {
                              return false;
                            }

                            const committedDate = new Date(committedDeliveryDate);
                            const statDate = new Date(statisticalDate);

                            // Existing CMO acceptance-limit tolerance check
                            if (deliveryDateAccepetedFlag !== true) {
                              return false;
                            }

                            const lateBoundaryDate = new Date(committedDate);
                            lateBoundaryDate.setDate(lateBoundaryDate.getDate() - acceptanceLimitForLaterDeliveryDateChangeByCMO);

                            return lateBoundaryDate.getTime() > statDate.getTime();

                          })();

                          return (
                            <span
                              style={{
                                color: shouldHighlightDateRed ? "red" : "black",
                              }}
                            >
                              {dateFormated(
                                committedDeliveryDate,
                                "DD-MMM-YYYY",
                                ""
                              )}
                            </span>
                          );
                        })()}
                      </TableCell>

                      <TableCell
                        align="center"
                        className={`${classes.tableCellBody} ${classes.col1to5}`}
                      >
                        {row?.batchDetails &&
                          Object.keys(row?.batchDetails).length > 0 ? (
                          <BatchColumnStatusRoute 
                            poDashboardBatch={true} 
                            featuresAccess={featuresAccess} 
                            row={row} 
                            slDetailsData={slDetailsFromPODashboard[row?.scheduleLineDetails?.schrockenSLID]?.data}
                          />
                        ) : (
                          ""
                        )}
                      </TableCell>

                      {/* ABO Risk */}
                      <TableCell align="left" className={classes.tableCellBody}>
                        <EditAboRisk row={row} handleRefresh={handleRefreshWithSLData(row)} featuresAccess={featuresAccess} userAssociations={userAssociationData} selectedCMOs={selectedCMOs}
    selectedBrands={selectedBrands} col8to10Style={classes.col8to10} showPencilIcon={showPencilIcon}/>
                      </TableCell>

                      {/* PO Status */}
                      <TableCell className={`${classes.tableCellBody} ${classes.col8to10}`}>
                        {renderPOStatusButton(
                          row?.scheduleLineDetails?.scheduleLineStatusID,
                          row?.scheduleLineDetails?.scheduleLineStatusText
                        )}
                      </TableCell>

                      {/* Action Button (dropdown menu) */}
                      <TableCell
                        align="center"
                        style={{ textAlign: "center" }}
                        className={`${classes.tableCellBody} ${classes.col8to10}`}
                      >
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Button
                            onClick={(e) => handleClick(e, row, index)}
                            className="classes.col8to10"
                            style={{
                             
                              backgroundColor: "black",
                              color: "white",
                              textTransform: "none",
                              borderRadius: "20px",
                              padding: "8px 16px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              
                            }}
                          >
                            Choose the action
                            <KeyboardArrowDownIcon
                              style={{ fontSize: "20px", fontWeight: "bold" }}
                            />
                          </Button>
                        </div>
                        <Menu
                          anchorEl={anchorEl}
                          open={openMenu}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          getContentAnchorEl={null}
                          PaperProps={{
                            style: {
                              backgroundColor: "black",
                              color: "white",
                              borderRadius: "8px",
                              width: "12rem",
                              marginTop: "8px",
                            },
                          }}
                        >
                          {featuresAccess?.actionViewPoHistory && (
                            <MenuItem
                              onClick={() => handleOpenPoHistory()}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              View PO History
                            </MenuItem>
                          )}
                          {featuresAccess?.actionMostRecentChanges && (
                            <MenuItem
                              onClick={() => handleOpenAction()}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              View Three Most
                              <br /> Recent Changes
                            </MenuItem>
                          )}
                          {/* Example of conditionally showing "View ASN" */}
                          {/* {(rowInfo?.scheduleLineDetails
                            ?.scheduleLineStatusID === 25 ||
                            rowInfo?.scheduleLineDetails
                              ?.scheduleLineStatusID === 29 ||
                            rowInfo?.scheduleLineDetails
                              ?.scheduleLineStatusID === 30 ||
                            rowInfo?.scheduleLineDetails
                              ?.scheduleLineStatusID === 31) &&
                            (rowInfo?.batchDetails?.batchStatusID >= 48) && featuresAccess?.actionViewASN && (
                              <MenuItem
                                onClick={() => handleASNOpen()}
                                style={{ color: "white", fontSize: "14px" }}
                              >
                                View ASN
                              </MenuItem>
                            )} */}
                          {(featuresAccess?.cancelPO && rowInfo?.scheduleLineDetails?.enableCancelPO) && ((localStorage?.collabType !== "CMO") || (localStorage?.collabType === "CMO" && rowInfo?.scheduleLineDetails?.cmoToUsePOInterface === true)) && (
                            <MenuItem
                              onClick={handleOpenRequestCancelPO}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              Request to cancel PO
                            </MenuItem>
                          )}
                          {(featuresAccess?.reveiewCancelPO && rowInfo?.scheduleLineDetails?.cancellationRequestStatus === 'pending' && localStorage?.collabType === "CMO" ) &&  (
                            <MenuItem
                              onClick={handleOpenReviewPOCancellation}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              Review PO Cancellation
                            </MenuItem>
                          )}
                          {featuresAccess?.actionViewReasonCodes && (
                            <MenuItem
                              onClick={() => handleopenReasonCodes()}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              View Reason Codes
                            </MenuItem>
                          )}
                          {/* Sync PO / Sync Inventory (BCM-534) — shown only when the
                              feature is granted for this screen (feature_variable
                              syncPO / syncInventory from getFeaturesAccess). */}
                          {featuresAccess?.syncPO && (
                            <MenuItem
                              onClick={handleSyncPO}
                              disabled={syncNotApplicable}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              Sync PO
                            </MenuItem>
                          )}
                          {featuresAccess?.syncInventory && (
                            <MenuItem
                              onClick={handleSyncInventory}
                              disabled={syncNotApplicable}
                              style={{ color: "white", fontSize: "14px" }}
                            >
                              Sync Inventory
                            </MenuItem>
                          )}
                          {(rowInfo?.batchDetails?.batchStatusID === 40 && featuresAccess?.viewApproveRejectConsumedBatch) && (
                            <MenuItem
                              onClick={() => handleApproveRejectBatchOpen()}
                              style={{ color: "white", fontSize: "14px", textWrap: "auto" }}
                            >
                              Review variance/mismatch
                            </MenuItem>
                          )} 
                        </Menu>
                      </TableCell>
                    </TableRow>

                    {/* Collapsible Details */}
                    <TableRow>
                      <TableCell colSpan={10} style={{ padding: 0 }}>
                        <CollapsePODetails
                          open={open[poNumber]}
                          row={row}
                          handleRefresh={handleRefresh}
                          handleQuickSummaryRefresh={handleQuickSummaryRefresh}
                          openedPOTab={openedPOTab[poNumber]}
                          showPencilIcon={showPencilIcon}
                          handleOpenPOTab={(val) =>
                            handleOpenPOTab(poNumber, val)
                          }
                          slDetails={slDetailsFromPODashboard[row?.scheduleLineDetails?.schrockenSLID]}
                          slDetailsLoading={slDetailsFromPODashboardLoading}
                        />
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <Dialog
        fullScreen
        open={openPoHistory}
        onClose={() => setOpenPoHistory(false)}
      >
        <DialogContent>
          <AuditReportNew
            rowInfo={rowInfo}
            poLineAuditsNewData={poLineAuditsNewData}
            poLineAuditsNewDataLoading={poLineAuditsNewDataLoading}
            setOpenPoHistory={setOpenPoHistory}
          />
        </DialogContent>
      </Dialog>

      {openAction && (
        <ViewThreeRecentChanges
          openAction={openAction}
          setOpenAction={setOpenAction}
          rowInfo={rowInfo}
          poLineAuditsNewData={poLineAuditsNewData}
          poLineAuditsNewDataLoading={poLineAuditsNewDataLoading}
        />
      )}

      {openASN && (
        <ViewASNDetails
          openASN={openASN}
          setOpenASN={setOpenASN}
          rowInfo={rowInfo}
        />
      )}

      {openReasonCode && (
        <ViewReasonCode
          openReasonCode={openReasonCode}
          setOpenReasonCode={setOpenReasonCode}
          rowInfo={rowInfo}
        />
      )}

      <Dialog
        open={openRequestCancelPO}
        // onClose={handleCloseRequestCancelPO}
        maxWidth="sm"
        fullWidth
      >
        <div style={{ position: "relative" }}>
          {requestCancelPOLoading && (
            <div style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.75)",
              zIndex: 10,
              borderRadius: 4,
            }}>
              <CircularProgress color="primary" />
            </div>
          )}
          <DialogTitle disableTypography style={{ padding: "16px 24px 0px 24px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Typography style={{ color: "#000", fontSize: 14 }}>Cancel</Typography>
              <IconButton onClick={handleCloseRequestCancelPO} style={{ color: "#FF0000" }} disabled={requestCancelPOLoading}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%", background: "#ffffff", borderRadius: 8, padding: "0px 24px 24px 24px", textAlign: "center" }}>
              <Typography variant="h5" style={{ fontWeight: 600, marginBottom: "40px" }}>
                Are you sure you want to send a cancellation request for the PO {rowInfo?.scheduleLineDetails?.scheduleAgreementNumber || ""} to CMO?
              </Typography>
              {requestCancelPOError && (
                <Typography style={{ color: "#FF0000", marginBottom: 16, fontSize: 14 }}>
                  {requestCancelPOError}
                </Typography>
              )}
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleContinueRequestCancelPO}
                  variant="contained"
                  disabled={requestCancelPOLoading}
                  style={{ backgroundColor: "#F36A0A", color: "white", textTransform: "none", borderRadius: 24, padding: "12px 32px" }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </DialogContent>
        </div>
      </Dialog>

      <Dialog
        open={openReviewPOCancellation}
        // onClose={handleCloseReviewPOCancellation}
        maxWidth="md"
        fullWidth
      >
        <div style={{ position: "relative" }}>
          {reviewCancellationLoading && (
            <div style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.75)",
              zIndex: 10,
              borderRadius: 4,
            }}>
              <CircularProgress color="primary" />
            </div>
          )}
        <DialogTitle disableTypography style={{ padding: "16px 24px", position: "relative" }}>
          <Typography variant="h5" style={{ fontWeight: 600, textAlign: "center", width: "100%" }}>
            Review PO Cancellation
          </Typography>
          <div style={{ position: "absolute", right: 16, top: 12, display: "flex", alignItems: "center", gap: 8 }}>
            <Typography style={{ color: "#000", fontSize: 14 }}>Cancel</Typography>
            <IconButton onClick={handleCloseReviewPOCancellation} style={{ color: "#FF0000" }} disabled={reviewCancellationLoading}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "32px 24px", display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%", maxWidth: 840, background: "#ffffff", borderRadius: 8, padding: "24px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: "24px", marginBottom: 32 }}>
              <div>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  PO Number
                </Typography>
                <Typography variant="body1">
                  {rowInfo?.scheduleLineDetails?.scheduleAgreementNumber || "-"}
                </Typography>
              </div>
              <div>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  Cancellation request by
                </Typography>
                <Typography variant="body1">
                  {rowInfo?.scheduleLineDetails?.cancellationRequestedBy || "-"}
                </Typography>
              </div>
              <div>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  Timestamp
                </Typography>
                <Typography variant="body1">
                  {rowInfo?.scheduleLineDetails?.cancellationRequestedDate || "-"}
                </Typography>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "24px", marginBottom: 24 }}>
              <div>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  Reason Code / Description
                </Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    displayEmpty
                    value={selectedCancellationReason}
                    onChange={(event) => setSelectedCancellationReason(event.target.value)}
                    renderValue={(v) => {
                      if (!v) return "";
                      const found = reasonCodes.find(rc => rc.reasonCode === v);
                      return found ? `${found.reasonCode} / ${found.reasonDescription}` : v;
                    }}
                    disabled={reasonCodesLoading}
                  >
                    <MenuItem value="">Reason Code / Description</MenuItem>
                    {reasonCodes.map((rc) => (
                      <MenuItem key={`${rc.reasonCodeID}-${rc.reasonCode}`} value={rc.reasonCode}>
                        {`${rc.reasonCode} / ${rc.reasonDescription}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  Comment
                </Typography>
                <TextField
                  placeholder="Enter text here"
                  value={cancellationComment}
                  onChange={(event) => { setCancellationComment(event.target.value); setCommentError(false); setCommentErrorText(""); }}
                  multiline
                  rows={4}
                  variant="outlined"
                  fullWidth
                  error={commentError}
                  helperText={commentError ? commentErrorText : ""}
                />
              </div>
            </div>

            <Typography variant="caption" style={{ marginBottom: 24, display: "block" }}>
              Note - If reason code is not entered, comment field is mandatory.
            </Typography>

            {reviewCancellationError && (
              <Typography style={{ color: "#FF0000", marginBottom: 16, fontSize: 14, textAlign: "center" }}>
                {reviewCancellationError}
              </Typography>
            )}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "120px", marginTop: 8 }}>
              <Button
                onClick={handleRejectReviewCancellation}
                variant="contained"
                disabled={reviewCancellationLoading}
                style={{ backgroundColor: "#0098FF", color: "white", textTransform: "none", borderRadius: 24, padding: "12px 32px" }}
              >
                Reject Cancellation
              </Button>
              <Button
                onClick={handleApproveReviewCancellation}
                variant="contained"
                disabled={reviewCancellationLoading}
                style={{ backgroundColor: "#F36A0A", color: "white", textTransform: "none", borderRadius: 24, padding: "12px 32px" }}
              >
                Approve Cancellation
              </Button>
            </div>
          </div>
        </DialogContent>
        </div>
      </Dialog>

     
      {/* {openApproveRejectBatch && (
        <ApproveRejectConsumedBatch
          open={openApproveRejectBatch}
          onClose={() => setOpenApproveRejectBatch(false)}
          rowInfo={rowInfo}
          onRefresh={handleRefresh}
          source="poDashboard"
        />
      )} */}

      <VarianceMismatchDialog
        open={openApproveRejectBatch}
        handleClose={() => setOpenApproveRejectBatch(false)}
        row={rowInfo ? {
          ...rowInfo.batchDetails,
          ...rowInfo.scheduleLineDetails,
          vendorName: rowInfo.scheduleLineDetails?.vendorName || rowInfo.scheduleLineDetails?.cmoName,
          batchUOM: rowInfo.batchDetails?.batchUOM || rowInfo.scheduleLineDetails?.targetQuantityUOM,
          // from batchDetails
          producedQuantity: rowInfo.batchDetails?.producedQuantity ?? null,
          reviewVarianceReqd: rowInfo.batchDetails?.reviewVarianceReqd ?? false,
          consumptionSameAsAllocation: rowInfo.batchDetails?.consumptionSameAsAllocation ?? false,
          // from scheduleLineDetails
          producedQtyVariancePresent: rowInfo.scheduleLineDetails?.producedQtyVariancePresent ?? false,
          producedQtyVarianceValue: rowInfo.scheduleLineDetails?.producedQtyVarianceValue ?? null,
          statDateVariancePresent: rowInfo.scheduleLineDetails?.statDateVariancePresent ?? false,
          poQuantity: rowInfo.scheduleLineDetails?.poQuantity ?? rowInfo.scheduleLineDetails?.targetQuantity ?? 0,
        } : null}
        onRefreshData={handleRefresh}
      />

      {/* Sync in-progress overlay (BCM-534) */}
      <Dialog open={syncLoading}>
        <DialogContent
          style={{ display: "flex", alignItems: "center", gap: 16, padding: "28px 32px" }}
        >
          <CircularProgress size={28} />
          <Typography style={{ fontSize: 14 }}>Syncing from SAP…</Typography>
        </DialogContent>
      </Dialog>

      {/* Sync PO / Sync Inventory — success popup. Same look as the app-wide
          StyledDialog (green check + title + OK), but WITHOUT the top-right
          "Close ✕" — the OK button already closes it (no need for two). */}
      <Dialog
        open={syncResultDialog.open && syncResultDialog.success}
        onClose={() => setSyncResultDialog({ open: false, success: false, title: "", message: "" })}
        fullWidth
        maxWidth="xs"
      >
        <DialogContent style={{ padding: "2rem", textAlign: "center" }}>
          <CheckCircleIcon style={{ fontSize: "5rem", color: "#39811D" }} />
          <Typography
            variant="h5"
            style={{ textAlign: "center", padding: "0.5rem", fontWeight: 500, fontSize: "1.5rem" }}
          >
            {syncResultDialog.title}
          </Typography>
          <div style={{ textAlign: "center", padding: "0.5rem", marginTop: "1.75rem" }}>
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => setSyncResultDialog({ open: false, success: false, title: "", message: "" })}
            >
              OK
            </StyledButton>
          </div>
        </DialogContent>
      </Dialog>

      {/* Sync PO / Sync Inventory — error popup (same style, with the reason). */}
      <Dialog
        open={syncResultDialog.open && !syncResultDialog.success}
        onClose={() => setSyncResultDialog({ open: false, success: false, title: "", message: "" })}
        fullWidth
        maxWidth="xs"
        PaperProps={{ style: { borderRadius: 12, padding: "2rem 1.5rem", textAlign: "center" } }}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: "#e53935",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ color: "white", fontSize: 36, lineHeight: 1 }}>✕</span>
          </div>
          <Typography variant="h6" style={{ fontWeight: 700, margin: 0 }}>
            {syncResultDialog.title}
          </Typography>
          {syncResultDialog.message && (
            <Typography variant="body2" style={{ color: "#555" }}>
              {syncResultDialog.message}
            </Typography>
          )}
          <Button
            onClick={() => setSyncResultDialog({ open: false, success: false, title: "", message: "" })}
            style={{
              textTransform: "none",
              minWidth: 90,
              backgroundColor: "#e65100",
              color: "white",
              borderRadius: 20,
              fontWeight: 600,
              padding: "6px 24px",
            }}
          >
            Ok
          </Button>
        </div>
      </Dialog>

    </>
  );
};

export default PurchaseOrderTabTable;
